export default __webpack_public_path__ + "static/media/footerEmailUsIcon.5db1c996.svg";